import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// const clientId = process.env.REACT_APP_CLIENT_ID || "";
const clientId = "J9RT2avgxoWrmZjNvhnSYTyROwTyhE4W";

export const registrationV2 = createApi({
  reducerPath: "registrationV2",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_APIURL }),
  tagTypes: ["RegistrationV2"],
  endpoints: (builder) => ({
    registerBusiness: builder.mutation({
      query: ({ businessData, accessToken }) => ({
        url: `/ziyl/business/register`,
        method: "POST",
        headers: {
          "content-type": "application/json",
          AuthorizationBiz: `Bearer ${accessToken}`,
        },
        body: businessData,
      }),
    }),
    businessAuth: builder.mutation({
      query: () => ({
        url: `/ziyl/business/get-token`,
        method: "GET",
      }),
    }),
    businessRegisterNaturalPerson: builder.mutation({
      query: ({data, accessToken}) => ({
        url: `/ziyl/business-person/register`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          AuthorizationBiz: `Bearer ${accessToken}`,
        },
      }),
    }),
    businessRegisterNonNaturalPerson: builder.mutation({
      query: ({data, accessToken}) => ({
        url: `/ziyl/non-natural-person/register`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          AuthorizationBiz: `Bearer ${accessToken}`,
        },
      }),
    }),
    businessRegistrationUploadDocument: builder.mutation({
      query: ({ data, accessToken }) => ({
        url: `/ziyl/document`,
        method: "POST",
        headers: {
          "AuthorizationBiz": `Bearer ${accessToken}`
        },
        body: data,
      }),
    }),
    businessAddComposition: builder.mutation({
      query: ({ data, accessToken }) => ({
        url: `/ziyl/business/composition`,
        method: "POST",
        headers: {
          "AuthorizationBiz": `Bearer ${accessToken}`,
        },
        body: data,
      }),
    }),
    businessSubmit: builder.mutation({
      query: ({ businessId, accessToken }) => {
        return {
          url: `/ziyl/business/${businessId}/submit`,
          method: "PUT",
          headers: {
            "AuthorizationBiz": `Bearer ${accessToken}`,
          },
          body: {
            business_id: businessId,
          },
        };
      },
    }),
    smsAccountRegistrationVerification: builder.mutation({
      query: ({ identifier }) => ({
        url: `/ziyl/getregistrationotpfinxp`,
        method: "POST",
        body: {
          identifier,
        },
      }),
    }),
    sumsubToken: builder.query({
      query: (sumsubUserId) => {
        return {
          url: `/ziyl/sumsubToken/${sumsubUserId}`,
          method: "GET",
        };
      },
      invalidatesTags: ["RegistrationV2"],
    }),
  }),
});

export const {
  useRegisterBusinessMutation,
  useBusinessRegisterNaturalPersonMutation,
  useBusinessRegisterNonNaturalPersonMutation,
  useBusinessRegistrationUploadDocumentMutation,
  useBusinessSubmitMutation,
  useBusinessAddCompositionMutation,
  useBusinessAuthMutation,
  useSmsAccountRegistrationVerificationMutation,
  useLazySumsubTokenQuery,
} = registrationV2;
